import { computed, onMounted } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2d32aec3"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "detail-table"
};
import { useRoute } from 'vue-router';
import DetailTable from '../components/DetailTable.vue';
import DetailPayTable from '../components/DetailPayTable.vue';
import DetailIosTable from '../components/DetailIosTable.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const myRoute = useRoute();
    const pathType = computed(() => {
      if (myRoute.query.type == 'bill') {
        return 'bill';
      } else if (myRoute.query.type && myRoute !== null && myRoute !== void 0 && myRoute.query.type.includes('Order')) {
        return 'order';
      } else if (myRoute.query.type && myRoute !== null && myRoute !== void 0 && myRoute.query.type.includes('Ios')) {
        return 'ios';
      }
    });
    onMounted(() => {});
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(pathType) == 'bill' ? (_openBlock(), _createBlock(DetailTable, {
        key: 0
      })) : _createCommentVNode("", true), _unref(pathType) == 'order' ? (_openBlock(), _createBlock(DetailPayTable, {
        key: 1
      })) : _createCommentVNode("", true), _unref(pathType) == 'ios' ? (_openBlock(), _createBlock(DetailIosTable, {
        key: 2
      })) : _createCommentVNode("", true)]);
    };
  }
});